const siteId = $('[name=siteId]').val() || 2;
const env = (() => {
  const hostname = window.location.hostname;
  if (/\.test/.test(hostname)) {
    return 'test';
  }
  if (/staging/.test(hostname)) {
    return 'staging';
  }
  return 'prod';
})();
const SiteConfig = {
  38: {
    cname: '青海',
    name: 'qinghai',
    pId: 3110,
    districtCode: 630000,
    catalogCode: 'PurchaseCategory' // 采购目录分类code
  },
  39: {
    cname: '新疆',
    name: 'xinjiang',
    pId: 3192,
    districtCode: 650000,
    catalogCode: 'xjcgPurchaseCategory'
  },
  29: {
    cname: '贵港',
    name: 'guigang',
    districtCode: 450800
  },
  58: {
    cname: '乌海',
    name: 'wuhai',
    pId: 377,
    districtCode: 150300
  },
  61: {
    cname: '广西',
    name: 'guangxi',
    pId: 2133,
    districtCode: 450000
  },
  62: { districtCode: 430000, cname: '湖南省', pId: 1846, name: 'hunan', catalogCode: 'hnCategory116' },
  63: { districtCode: 430100, cname: '长沙市', pId: 1847, name: 'changsha', catalogCode: 'hnCategory116' },
  64: { districtCode: 430200, cname: '株洲市', pId: 1858, name: 'zhuzhou', catalogCode: 'hnCategory116' },
  65: { districtCode: 430300, cname: '湘潭市', pId: 1868, name: 'xiangtan', catalogCode: 'hnCategory116' },
  66: { districtCode: 430400, cname: '衡阳市', pId: 1874, name: 'hengyang', catalogCode: 'hnCategory116' },
  67: { districtCode: 430500, cname: '邵阳市', pId: 1887, name: 'shaoyang', catalogCode: 'hnCategory116' },
  68: { districtCode: 430600, cname: '岳阳市', pId: 1900, name: 'yueyang', catalogCode: 'hnCategory116' },
  69: { districtCode: 430700, cname: '常德市', pId: 1910, name: 'changde', catalogCode: 'hnCategory116' },
  70: { districtCode: 430800, cname: '张家界市', pId: 1920, name: 'zhangjiajie', catalogCode: 'hnCategory116' },
  71: { districtCode: 430900, cname: '益阳市', pId: 1925, name: 'yiyang', catalogCode: 'hnCategory116' },
  72: { districtCode: 431000, cname: '郴州市', pId: 1932, name: 'chenzhou', catalogCode: 'hnCategory116' },
  73: { districtCode: 431100, cname: '永州市', pId: 1944, name: 'yongzhou', catalogCode: 'hnCategory116' },
  73: { districtCode: 431200, cname: '怀化市', pId: 1956, name: 'huaihua', catalogCode: 'hnCategory116' },
  74: { districtCode: 431300, cname: '娄底市', pId: 1969, name: 'loudi', catalogCode: 'hnCategory116' },
  75: { districtCode: 433100, cname: '湘西土家族苗族自治州', pId: 1975, name: 'xiangxi', catalogCode: 'hnCategory116' },
  77: { districtCode: 310000, cname: '上海', pId: 805, name: 'shanghai', catalogCode: 'shCategory123' },
  78: { districtCode: 140000, cname: '山西', pId: 225, name: 'shanxi'  },
  79: { districtCode: 450200, cname: '柳州', pId: 225, name: 'liuzhou'  },
};

function getZcyDomain(type) {
  if (Config.env === 'test') {
    return `http://${type}.test.zcygov.cn`;
  } else if (Config.env === 'staging') {
    return `https://${type}-staging.zcygov.cn`;
  }
  return `https://${type}.zcygov.cn`;
}

const Config = $.extend({ siteId, env, getZcyDomain }, _.omit(SiteConfig[siteId], ['cname', 'name']));
module.exports = Config;
